import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import AppShell from '@/components/layout/AppShell';
import AdminPanel from '@/pages/AdminPanel';
import AgentDelegations from '@/pages/AgentDelegations';
import GenreCatalog from '@/pages/GenreCatalog';
import Production from '@/pages/Production';
import ProjectDashboard from '@/pages/ProjectDashboard';
import Projects from '@/pages/Projects';
import ScriptInput from '@/pages/ScriptInput';
import StyleCatalog from '@/pages/StyleCatalog';

function App() {
  return (
    <BrowserRouter>
      <AppShell>
        <Routes>
          <Route path="/" element={<Navigate to="/projects" replace />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/genres" element={<GenreCatalog />} />
          <Route path="/styles" element={<StyleCatalog />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/delegations" element={<AgentDelegations />} />
          <Route path="/projects/new" element={<ScriptInput />} />
          <Route path="/projects/:id" element={<ProjectDashboard />} />
          <Route path="/projects/:projectId/productions/:id" element={<Production />} />
          {/* Legacy route for ad-hoc productions */}
          <Route path="/production/:id" element={<Production />} />
        </Routes>
      </AppShell>
    </BrowserRouter>
  );
}

export default App;
